import axios, { AxiosPromise } from 'axios';

import { FeatureToggleContract } from '../../types/feature-toggle-contract';

export const GET_FEATURE_TOGGLES_URL = '/settings/account/features';

export const getFeatureToggles = (): AxiosPromise<FeatureToggleContract> => {
    return axios.get(GET_FEATURE_TOGGLES_URL);
};
